<div class="admin-container">
  <form class="form">
    <div class="input-group">
      <label>Mention</label>
      <app-text-editor
        [(ngModel)]="sectionData.text"
        [name]="sectionData.id + 'mention'"
      ></app-text-editor>
    </div>
  </form>
</div>
